<template>
  <section>
    <h3 class="primary--text">
      <v-icon color="primary">business</v-icon>Registro de Conciliación
    </h3>
    <div>
      <v-toolbar flat color="white">
        <v-toolbar-title>Conciliación</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-dialog v-model="dialog2" max-width="800px" persistent>
          <v-card class="elevation-2" max-width="800">
            <v-timeline align-top>
              <v-timeline-item
                v-for="(item, i) in tramites"
                :color="item.color"
                :icon="item.icon"
                :key="i"
                fill-dot
              >
                <v-layout justify-center>
                  <v-card :color="item.color" dark>
                    <v-card-title class="title">{{item.etapa}}</v-card-title>
                    <v-card-text class="white text--primary">
                      <p>{{item.proveido}}</p>
                      <p>{{item.fecha | formatDate}}</p>
                      <p>{{item['res_tramite.persona.nombre_completo']}}</p>
                      <v-btn :color="item.color" class="mx-0" outline>Button</v-btn>
                    </v-card-text>
                  </v-card>
                </v-layout>
              </v-timeline-item>
            </v-timeline>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click.native="close2">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogPriInv" max-width="900px" persistent>
          <v-card color="grey lighten-3">
            <v-card-title class="headline grey lighten-2" primary-title>
              <span>{{ !filaActual.etapa ? 'Primera invitación' : ( filaActual.etapa === 'PRIMERA_INVITACION' ? 'Segunda invitación': 'Tercera invitación')}}</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <!-- Data iterator para los usuarios -->
                  <v-btn color="primary" value="Invitado" @click.native.stop="crearObj()">
                    <v-icon dark>person_add</v-icon>&nbsp; Invitado
                  </v-btn>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-data-iterator
                        :items="invitados"
                        content-tag="v-layout"
                        row
                        wrap
                        hide-actions
                        hide-headers
                      >
                        <v-flex slot="item" slot-scope="props" xs12>
                          <v-card v-model="card">
                            <v-card-text>
                              <v-container grid-list-md>
                                <v-layout wrap>
                                  <v-icon
                                    @click="deleteItem(props.item)"
                                    class="mr-2"
                                    color="red accent-4"
                                  >close</v-icon>
                                  <v-flex xs12 sm6 md2>
                                    <v-text-field label="CI" v-model="props.item.nro_documento"></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm6 md3>
                                    <v-text-field label="Nombre" v-model="props.item.nombres"></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm6 md3>
                                    <v-text-field
                                      label="Primer apellido"
                                      v-model="props.item.primer_apellido"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm6 md3>
                                    <v-text-field
                                      label="Segundo apellido"
                                      v-model="props.item.segundo_apellido"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm6 md2>
                                    <v-text-field label="Telefono" v-model="props.item.telefono"></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm6 md4>
                                    <v-text-field label="Dirección" v-model="props.item.direccion"></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-data-iterator>
                    </v-layout>
                  </v-container>
                  <!-- Fin del data iterator -->
                  <v-card-text class="light-blue--text">Horario</v-card-text>
                  <v-flex xs12 sm6 md4>
                    <v-menu
                      :close-on-content-click="false"
                      v-model="menu2"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="date"
                        label="Fecha Invitación"
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker v-model="date" @input="menu2 = false" locale="es-419"></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs11 sm5>
                    <v-dialog
                      ref="dialogHora"
                      v-model="modal2"
                      :return-value.sync="time"
                      persistent
                      lazy
                      full-width
                      width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="time"
                        label="Picker in dialog"
                        prepend-icon="access_time"
                        readonly
                      ></v-text-field>
                      <v-time-picker v-if="modal2" v-model="time" full-width>
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="modal2 = false">Cancel</v-btn>
                        <v-btn flat color="primary" @click="$refs.dialogHora.save(time)">OK</v-btn>
                      </v-time-picker>
                    </v-dialog>
                  </v-flex>

                  <v-flex xs12>
                    <v-textarea
                      v-model="editedItem.proveido"
                      auto-grow
                      box
                      color="blue"
                      label="Proveído"
                      rows="1"
                      counter="150"
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs12>
                    <file-upload
                      :url="urlFile"
                      types=".pdf"
                      name="nombreDocumento"
                      :form="form1"
                      :on-success="onSuccess"
                      label="Arrastre el PDF de su archivo  aquí <br>o haga clic aquí para subir su archivo"
                    ></file-upload>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" flat @click.native="cerrarPriInv">Cancelar</v-btn>
              <v-btn color="blue darken-1" flat @click.native="savePrimeraInvitacion">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Modificación de invitados -->

       <v-dialog v-model="dialogModInv" max-width="900px" persistent>
          <v-card color="grey lighten-3">
            <v-card-title class="headline grey lighten-2" primary-title>
              <span>{{ !filaActual.etapa ? 'Primera invitación' : ( filaActual.etapa === 'PRIMERA_INVITACION' ? 'Segunda invitación': 'Tercera invitación')}}</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <!-- Data iterator para los usuarios -->
                  <v-btn color="primary" value="Invitado" @click.native.stop="crearObj()">
                    <v-icon dark>person_add</v-icon>&nbsp; Invitado
                  </v-btn>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-data-iterator
                        :items="invitados"
                        content-tag="v-layout"
                        row
                        wrap
                        hide-actions
                        hide-headers
                      >
                        <v-flex slot="item" slot-scope="props" xs12>
                          <v-card v-model="card">
                            <v-card-text>
                              <v-container grid-list-md>
                                <v-layout wrap>
                                  <v-icon
                                    @click="deleteItem(props.item)"
                                    class="mr-2"
                                    color="red accent-4"
                                  >close</v-icon>
                                  <v-flex xs12 sm6 md2>
                                    <v-text-field label="CI" v-model="props.item.nro_documento"></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm6 md3>
                                    <v-text-field label="Nombre" v-model="props.item.nombres"></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm6 md3>
                                    <v-text-field
                                      label="Primer apellido"
                                      v-model="props.item.primer_apellido"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm6 md3>
                                    <v-text-field
                                      label="Segundo apellido"
                                      v-model="props.item.segundo_apellido"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm6 md2>
                                    <v-text-field label="Telefono" v-model="props.item.telefono"></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm6 md4>
                                    <v-text-field label="Dirección" v-model="props.item.direccion"></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-data-iterator>
                    </v-layout>
                  </v-container>
                  <!-- Fin del data iterator -->
              

                 
                 
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" flat @click.native="cerrarModInv">Cancelar</v-btn>
              <v-btn color="blue darken-1" flat @click.native="modificarInvitados">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- fin del dialog modificación de invitados -->

        <v-dialog v-model="dialogSolucion" max-width="700px" persistent>
          <v-card>
            <v-card-title class="headline grey lighten-3" primary-title>Solución</v-card-title>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-subheader>CI Solicitante:</v-subheader>
                  <v-card-text>
                    <p class="text-sm-left">{{filaActual.ci}}</p>
                  </v-card-text>
                </v-flex>

                <v-flex xs12 sm6>
                  <v-subheader>Nombre Solicitante:</v-subheader>
                  <v-card-text>
                    <p class="text-sm-left">{{filaActual.solicitante}}</p>
                  </v-card-text>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-select
                    v-model="select_solucion"
                    :items="solucion"
                    item-text="valor"
                    item-value="clave"
                    label="Forma de solución"
                    persistent-hint
                    return-object
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menuSolucion"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="dateSolucion"
                      label="Fecha Solución"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="date" @input="menuSolucion = false" locale="es-419"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="datosSolucion.numeroActa" label="Número de Acta"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="datosSolucion.conclusion"
                    auto-grow
                    box
                    color="blue"
                    label="Conclusión"
                    rows="3"
                    counter="150"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" flat @click.native="cerrarSolucion">Cancelar</v-btn>
              <v-btn color="blue darken-1" flat @click.native="saveSolucion">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogEnviar" max-width="700px" persistent>
          <v-card>
            <v-card-title class="headline grey lighten-3" primary-title>Envío de la conciliación</v-card-title>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-subheader>CI Solicitante:</v-subheader>
                  <v-card-text>
                    <p class="text-sm-left">{{filaActual.ci}}</p>
                  </v-card-text>
                </v-flex>

                <v-flex xs12 sm6>
                  <v-subheader>Nombre Solicitante:</v-subheader>
                  <v-card-text>
                    <p class="text-sm-left">{{filaActual.solicitante}}</p>
                  </v-card-text>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    v-model="select_etapa"
                    :items="flujoDestino"
                    item-text="flujo_destino"
                    item-value="flujoDestino"
                    label="Enviar a"
                    persistent-hint
                    return-object
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    v-model="select_abogado"
                    :items="abogado"
                    item-text="nombre"
                    item-value="id"
                    label="Funcionario"
                    persistent-hint
                    return-object
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="proveido"
                    auto-grow
                    box
                    color="blue"
                    label="Proveído"
                    rows="3"
                    counter="100"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" flat @click.native="closeEnviar">Cancelar</v-btn>
              <v-btn color="blue darken-1" flat @click.native="saveEnvio">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <!-- Listado Conciliaciones -->
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
      </v-card-title>
      <v-data-table
      :headers="headers"
      :items="desserts"
      class="elevation-1"
      :pagination.sync="pagination"
        :total-items="pagination.totalItems"
        rowsPerPageText="Filas por página"
        noResultsText="No se encontraron registros que coincidan"
        noDataText="No hay resultados"
        :rowsPerPageItems="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td class="justify-right layout px-0">
            <v-tooltip bottom>
              <v-icon
                slot="activator"
                v-if="!props.item.etapa && ($util.isRol('ABOGADO') || $util.isRol('PSICOLOGO') ) && props.item.estado === 'ACTIVO'"
                color="light-blue "
                @click="invitacionConciliacion(props.item)"
              >local_post_office</v-icon>
              <span>Generar primera invitación</span>
            </v-tooltip>
             <v-tooltip bottom>
              <v-icon
                slot="activator"
                v-if="props.item.etapa  && ($util.isRol('ABOGADO') || $util.isRol('PSICOLOGO') )"
                color="light-blue "
                @click="modificacionInvitados(props.item)"
              >person</v-icon>
              <span>Modificar Invitados</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-icon
                slot="activator"
                v-if="props.item.etapa === 'PRIMERA_INVITACION' && ($util.isRol('ABOGADO') || $util.isRol('PSICOLOGO'))&& props.item.estado === 'ACTIVO'"
                color="light-blue "
                @click="invitacionConciliacion(props.item)"
              >drafts</v-icon>
              <span>Generar segunda invitación</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-icon
                slot="activator"
                v-if="props.item.etapa === 'SEGUNDA_INVITACION' && ($util.isRol('ABOGADO') || $util.isRol('PSICOLOGO')) && props.item.estado === 'ACTIVO'"
                color="light-blue "
                @click="invitacionConciliacion(props.item)"
              >mail_outline</v-icon>
              <span>Generar tercera invitación</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-icon
                slot="activator"
                v-if="props.item.etapa === 'PRIMERA_INVITACION' || props.item.etapa === 'SEGUNDA_INVITACION' || props.item.etapa === 'TERCERA_INVITACION'"
                color="light-blue"
                @click="solucionConciliacion(props.item)"
              >check_box</v-icon>
              <span>Registrar solución</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-icon
                slot="activator"
                color="light-green darken-4"
                class="mr-2"
                @click="flowItem(props.item)"
              >call_split</v-icon>
              <span>ver historial del caso</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-icon
                slot="activator"
                v-if="props.item.estado === 'ACTIVO'"
                class="mr-2"
                @click="enviarSolucion(props.item)"
                flat
                color="cyan lighten-2"
              >send</v-icon>
              <span>Enviar Caso</span>
            </v-tooltip>
          </td>
          <td>{{ props.item.codigo }}</td>
          <td class="text-xs-right">{{ props.item.ci }}</td>
          <td class="text-xs-right">{{ props.item.solicitante }}</td>
          <td class="text-xs-right">{{ props.item.enviado_por }}</td>
          <td class="text-xs-right">{{ props.item.fecha | formatDate }}</td>
          <td class="text-xs-right">{{ props.item.etapa }}</td>
          <td class="text-xs-right">{{ props.item.estado }}</td>
          <td>
            <template>
              <v-treeview :items="props.item.invitaciones">
                <v-icon
                  v-if="!item.children"
                  slot="prepend"
                  slot-scope="{ item }"
                  color="red accent-4"
                  @click="generarInvitacionPdf(item.id,item.name)"
                >picture_as_pdf</v-icon>
              </v-treeview>
            </template>
          </td>
          <td class="text-xs-right" v-if="$util.isRol('DIRECTOR')">{{ props.item.centro }}</td>
          <td class="text-xs-right" v-if="$util.isRol('DIRECTOR')">{{ props.item.abogado }}</td>
        </template>
        <template
              slot="pageText"
              slot-scope="{ pageStart, pageStop }"
            >{{ pageStart }}-{{ pageStop }} de {{ pagination.totalItems }}</template>
        <!-- <v-alert
          slot="no-results"
          :value="true"
          color="info"
          icon="warning"
        >Tu búsqueda para "{{ search }}" no obtuvo resultados</v-alert> -->
      </v-data-table>
    </div>
  </section>
</template>
<script>
import moment from 'moment';
import FileUpload from '@/common/util/FileUpload.vue';
export default {
  data: () => ({
    rowsPerPageItems: [5, 10, 20],
    pagination: {
      rowsPerPage: 5,
      page: 1
    },
    urlFile: '',
    documentosAdjuntos: [],
    nombreDocumento: '',
    form1: {},
    dialog: false,
    dialogHora: false,
    dialog2: false,
    dialogVisor: false,
    dialogSolucion: false,
    dialogPriInv: false,
    dialogModInv: false,
    dialogEnviar: false,
    filaActual: {},
    flujoDestino: [],
    select_idioma: { valor: 'Castellano', clave: 'CASTELLANO' },
    select_estado_civil: { valor: 'Soltero (a)', clave: 'SOLTERO' },
    select_genero: { valor: 'Femenino', clave: 'FEMENINO' },
    select_departamento: { nombre: 'La Paz', codigo: '02' },
    select_abogado: { nombre: 'Abogado', id: 0 },
    select_etapa: { valor: 'Conciliación', clave: 'CONCILIACION' },
    select_solucion: { valor: 'Acta', clave: 'CONCILIACION_SOLUCION' },
    idioma: [],
    tramites: [],
    estado_civil: [],
    genero: [],
    departamento: [],
    abogado: [],
    solucion: [],
    proveido: '',
    search: '',
    datosSolucion: {},
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,
    modal2: false,
    time: null,
    menuReloj: false,
    menuSolucion: false,
    dateSolucion: new Date().toISOString().substr(0, 10),
    items: [],
    headers: [],
    invitados: [],
    desserts: [],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
    primeraInvitacion: {},
    upInvitadosConciliacionId: null
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Datos del Solicitante' : 'Orientación ';
    },
    pages () {
      if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) {
        return 1;
      }
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },
  filters: {
    formatDate: function (value) {
      return moment(String(value)).format('DD/MM/YYYY HH:mm');
    }
  },

  watch: {
    dialog (val) {
      val || this.close();
    },
    select_etapa (val) {
      let prof = 'ABOGADO';
      if (val.flujo_destino === 'ARCHIVO') {
        prof = 'ABOGADO PSICOLOGO';
      }
      if (val.flujo_destino === 'PSICOLOGIA') {
        prof = 'PSICOLOGO';
      }
      if (val.flujo_destino === 'TRABAJO_SOCIAL') {
        prof = 'TRABAJADOR_SOCIAL';
      }
      this.$service['get'](`v1/centros/usuarios?tipo=${prof}`).then(
        response => {
          if (response) {
            this.abogado = response;
          }
        }
      );
    },
    pagination: function () {
      this.listarDatos();
    },
    search: function (filter) {
      this.listarDatos(filter);
    }
  },

  created () {
    this.urlFile = `${this.$apiUrl}v1/documentos`;
    this.initialize();
    if (this.$util.isRol('DIRECTOR')) {
      this.headers = [
        { text: 'Opciones', value: 'name', sortable: false },
        {
          text: 'Código',
          align: 'left',
          sortable: false,
          value: 'codigo'
        },
        { text: 'C. I.', value: 'ci' },
        { text: 'Solicitante', value: 'nombres' },
        { text: 'Enviado por', value: 'apellidos' },
        { text: 'Fecha de asignación', value: 'apellidos' },
        { text: 'Etapa', value: 'p_etapa' },
        { text: 'Estado', value: 'estado' },
        { text: 'Detalle', value: 'detalle' },
        { text: 'Centro', value: 'centro' },
        { text: 'Abogado', value: 'abogado' }
      ];
    } else {
      this.headers = [
        { text: 'Opciones', value: 'name', sortable: false },
        {
          text: 'Código',
          align: 'left',
          sortable: false,
          value: 'codigo'
        },
        { text: 'C. I.', value: 'ci' },
        { text: 'Solicitante', value: 'nombres' },
        { text: 'Enviado por', value: 'apellidos' },
        { text: 'Fecha de asignación', value: 'apellidos' },
        { text: 'Etapa', value: 'p_etapa' },
        { text: 'Estado', value: 'estado' },
        { text: 'Detalle', value: 'detalle' }
      ];
    }
  },
  components: {
    FileUpload
  },
  methods: {
    initialize () {
      this.listarDatos();
      this.$service['get']('v1/parametricas?grupo=IDIOMA').then(response => {
        if (response) {
          this.idioma = response;
        }
      });
      this.$service['get']('v1/parametricas?grupo=ESTADO_CIVIL').then(
        response => {
          if (response) {
            this.estado_civil = response;
          }
        }
      );
      this.$service['get']('v1/parametricas?grupo=GENERO').then(response => {
        if (response) {
          this.genero = response;
        }
      });
      this.$service['get']('v1/dpas/departamentos').then(response => {
        if (response) {
          this.departamento = response;
        }
      });
      this.$service['get']('v1/parametricas?grupo=TRAMITE_ETAPA').then(
        response => {
          if (response) {
            this.tramite = response;
          }
        }
      );
      this.$service['get']('v1/parametricas?grupo=CONCILIACION_SOLUCION').then(
        response => {
          if (response) {
            this.solucion = response;
          }
        }
      );
    },
    flowItem (item) {
      this.$service['get'](`v1/solicitudes/${item.solicitud_id}/tramites`).then(
        response => {
          this.tramites = response;
          this.dialog2 = true;
        }
      );
    },
    invitacionConciliacion (item) {
      this.filaActual = item;
      this.$service['get'](
        `v1/solicitudes/${item.solicitud_id}/primerasInvitaciones`
      ).then(response => {
        if (response.invitados) {
          this.invitados = response.invitados;
        } else {
          this.invitados = [];
        }
      });
      this.dialogPriInv = true;
    },
    modificacionInvitados (item) {
      this.filaActual = item;
      this.$service['get'](
        `v1/solicitudes/${item.solicitud_id}/primerasInvitaciones`
      ).then(response => {
        this.upInvitadosConciliacionId = response.conciliacion_id;
        if (response.invitados) {
          this.invitados = response.invitados;
        } else {
          this.invitados = [];
        }
      });
      this.dialogModInv = true;
    },
    visorItem (item) {
      this.filaActual = item;
      this.dialogVisor = true;
    },
    solucionConciliacion (item) {
      this.filaActual = item;
      this.dialogSolucion = true;
    },
    enviarSolucion (item) {
      this.filaActual = item;
      this.flujoDestino = item.flujo;
      this.dialogEnviar = true;
    },

    editItem (item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close () {
      this.limpiarFormulario();
      this.dialog = false;
    },
    close2 () {
      this.dialog2 = false;
    },
    closeVisor () {
      this.dialogVisor = false;
    },
    closeEnviar () {
      this.dialogEnviar = false;
    },
    cerrarPriInv () {
      this.dialogPriInv = false;
      this.items = [];
    },
    cerrarModInv () {
      this.dialogModInv = false;
      this.items = [];
    },
    cerrarSegInv () {
      this.dialogSegInv = false;
      this.items = [];
    },
    cerrarSolucion () {
      this.dialogSolucion = false;
      this.datosSolucion = {};
    },
    limpiarFormulario () {
      this.select_estado_civil = { valor: 'Soltero (a)', clave: 'SOLTERO' };
      this.select_genero = { valor: 'Femenino', clave: 'FEMENINO' };
      this.select_departamento = { nombre: 'La Paz', clave: '02' };
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      this.select_abogado = { nombre: 'Abogado', id: 0 };
    },
    saveOrientacion () {
      let data = {
        motivo: this.editedItem.motivo,
        conclusion: this.editedItem.conclusion
      };
      this.$service['patch'](
        `v1/orientaciones/${this.editedItem.id}`,
        data
      ).then(response => {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
        this.close();
      });
    },
    savePrimeraInvitacion () {
      let etapa = !this.filaActual.etapa
        ? 'PRIMERA_INVITACION'
        : this.filaActual.etapa === 'PRIMERA_INVITACION'
        ? 'SEGUNDA_INVITACION'
        : 'TERCERA_INVITACION';
      if (this.invitados.length > 0) {
        let dataDetalle = {
          etapa_conciliacion: etapa,
          invitados: this.invitados,
          fecha_invitacion: this.date,
          hora_invitacion: this.time,
          observacion: this.editedItem.proveido
        };
        this.$service['post'](
          `v1/conciliaciones/${this.filaActual.id}/detalles`,
          dataDetalle
        ).then(response => {
          this.filaActual.etapa = etapa;
          this.items = [];
          this.desserts = [];
          this.listarDatos();
          this.dialogPriInv = false;
        });
      } else {
        this.$message.error('Debe ingresar al menos el nombre de la parte invitada');
      }
    },
    modificarInvitados () {
      //  let etapa = !this.filaActual.etapa  ? 'PRIMERA_INVITACION' : ( this.filaActual.etapa  === 'PRIMERA_INVITACION' ? 'SEGUNDA_INVITACION': 'TERCERA_INVITACION');
      if (this.invitados.length > 0) {
        this.$service['patch'](
          `v1/conciliaciones/${this.upInvitadosConciliacionId}/invitaciones`, {
            invitados: this.invitados
          }
        ).then(response => {
          // this.filaActual.etapa = 'SOLUCION';
          // this.datosSolucion = {};
          // this.dateSolucion = new Date().toISOString().substr(0, 10)
          this.$message.success(response.message);
          this.upInvitadosConciliacionId = null;
          this.dialogModInv = false;
        });
      } else {
        this.$message.error('Debe registrar al menos un invitado');
      }
    },
    saveSolucion () {
      //  let etapa = !this.filaActual.etapa  ? 'PRIMERA_INVITACION' : ( this.filaActual.etapa  === 'PRIMERA_INVITACION' ? 'SEGUNDA_INVITACION': 'TERCERA_INVITACION');
      let dataDetalle = {
        etapa: 'SOLUCION',
        solucion: this.select_solucion,
        fecha_solucion: this.dateSolucion,
        nro_acta: this.datosSolucion.numeroActa,
        conclusion_final: this.datosSolucion.conclusion
      };
      this.$service['patch'](
        `v1/conciliaciones/${this.filaActual.id}`,
        dataDetalle
      ).then(response => {
        this.filaActual.etapa = 'SOLUCION';
        this.datosSolucion = {};
        this.dateSolucion = new Date().toISOString().substr(0, 10);
        this.dialogSolucion = false;
      });
    },
    crearObj () {
      this.invitados.push({
        nro_documento: '',
        nombres: '',
        primer_apellido: '',
        segundo_apellido: '',
        telefono: ''
      });
    },
    deleteItem (item) {
      const index = this.invitados.indexOf(item);
      confirm('Está seguro de borrar al invitado?') &&
        this.invitados.splice(index, 1);
    },
    saveEnvio () {
      let data = {
        flujo_actual_key: this.filaActual.flujo_actual_key,
        flujo_actual_id: this.filaActual.id,
        flujo_destino: this.select_etapa.flujo_destino,
        flujo_destino_key: this.select_etapa.flujo_destino_key,
        proveido: this.proveido,
        responsable_id: this.select_abogado.id
      };
      this.$service['patch']('v1/casos', data).then(response => {
        // ACTUAIZA TABLA
        this.listarDatos();
        this.dialogEnviar = false;
      });
    },
    generarflujo () {
      this.$service['get'](
        `v1/solicitudes/${this.filaActual.solicitud_id}/tramites`
      ).then(response => {
        this.dialog2 = true;
      });
    },
    generarInvitacionPdf (idDet, invitacion) {
      this.$service
        .get(
          `v1/conciliaciones/detalles/${idDet}/invitacionesPdf?etapa=${invitacion}`
        )
        .then(response => {
          let fileType = 'application/pdf';
          let name = `${invitacion}.pdf`;
          let a = document.createElement('a');
          a.download = name;
          a.href = window.URL.createObjectURL(
            this.b64toBlob(response, 'application/pdf')
          );
          a.dataset.downloadurl = [fileType, a.download, a.href].join(':');
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          setTimeout(() => {
            URL.revokeObjectURL(a.href);
          }, 1500);
          this.$forceUpdate();
        });
    },
    b64toBlob (b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;
      let byteCharacters = atob(b64Data);
      let byteArrays = [];
      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);
        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      let blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    onSuccess (file, response) {
      if (Object.keys(response).length > 0) {
        this.documentosAdjuntos.push(response.nombre);
      } else {
        this.$message.error('Hubo un error en subir el archivo.');
      }
    },
    listarDatos (filter = '') {
      const { page, rowsPerPage } = this.pagination;
      this.$service['get'](`v1/conciliaciones?page=${page}&limit=${rowsPerPage}&q=${filter}`).then(response => {
        this.desserts = [];
        if (response) {
          this.pagination.totalItems = response.count;
          for (let item of response.rows) {
            this.desserts.push({
              ci: item.persona_solicitante.nro_documento,
              nombres: item.persona_solicitante.nombres,
              apellidos: `${item.persona_solicitante.primer_apellido ||
                ''} ${item.persona_solicitante.segundo_apellido || ''}`,
              solicitante: `${item.persona_solicitante.nombres} ${item
                .persona_solicitante.primer_apellido || ''} ${item
                .persona_solicitante.segundo_apellido || ''}`,
              abogado: `${item.persona_responsable.nombres} ${item
                .persona_responsable.primer_apellido || ''}`,
              enviado_por: `${item.persona_envio.nombres} ${item.persona_envio
                .primer_apellido || ''}`,
              fecha: item.fecha_creacion,
              codigo: item.codigo,
              id: item.id,
              flujo: item.flujo,
              flujo_actual_key: item.flujo_actual_key,
              solicitud_id: item.solicitud_id,
              estado: item.estado,
              etapa: item.p_etapa,
              centro: item.centro,
              invitaciones: [
                {
                  id: 1,
                  name: 'Invitaciones :',
                  children: item.invitaciones
                }
              ]
            });
          }
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/casos/conciliaciones/Conciliacion.vue